import { P } from '../../../../../../AbstractElements'
import { SideHeaderProp } from '../../../../../../Types/ChatType'
import { Href } from '../../../../../../Utils/Constants'

export default function SideHeader({title}: SideHeaderProp) {
    return (
        <div className="common-space d-flex">
            <P>{title}</P>
            <div className="header-top">
                <a className="btn f-w-500 badge-light-primary" href={Href}>
                    <i className="fa fa-plus"></i>
                </a>
            </div>
        </div>
    )
}
